import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ClientsTable from "components/Tables/ClientsTable.js";
import { useDispatch, useSelector } from "react-redux";
import { getClients } from "actions/clients";

const Clients = () => {
  const location = useLocation();
  const clients = useSelector((state) => state.clients.clients);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!clients) {
      dispatch(getClients());
    }
  }, [clients, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  return (
    <div>
      <ClientsTable clients={clients} />
    </div>
  );
};

export default Clients;
